module.exports = __webpack_public_path__ + "img/swift-bostergreen-gls-gris-acero.a44fe5c1.png";